<template>
    <div>
        <div v-if="permiso">
            <Upload :getImagenServicioOrganigrama="getImagenServicioOrganigrama"/>
        </div>
        <div>
            <div class="cnt-img" v-if="!sinDatos">
                <img v-show="url" id="imgMinisterioOrganigrama" :src="url" alt="" />
            </div>
        </div>
        <NoData v-if="!permiso && sinDatos" />
    </div>
</template>

<script>
import Upload from "./Button.vue";
import NoData from "../../../indicador/components/NoData.vue";
import { mapState } from "vuex";

import axios from "axios";
import { showAlert } from "../../../../components/tools/utils";
export default {
  components: {
    NoData,
    Upload,
  },
  data() {
    return {
      permiso: false,
      sinDatos: true,
      url: "",

    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    getImagenServicioOrganigrama: async function() {
      try {
        await axios
          .get(
            `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/` +
              this.$route.params.idServicio,
            {
              headers: {
                Authorization: `JWT ${localStorage.getItem("userToken")}`,
              },
            }
          )
          .then((r) => {
            if (r.data) {
              this.url =
                process.env.VUE_APP_RUTA_API_IMG + "" + r.data.organigrama;
              this.sinDatos = false;
            }
          })
          .catch((e) => {
            this.sinDatos = true;
            showAlert({
              icon: "error",
              text: e.response
                ? e.response.data[Object.keys(e.response.data)[0]]
                : "error",
              timerProgressBar: true,
              timer: 3000,
            });
          });
      } catch (error) {
        this.sinDatos = true;
        showAlert({
          icon: "error",
          text: error.response
            ? error.response.data[Object.keys(error.response.data)[0]]
            : "error",
          timerProgressBar: true,
          timer: 3000,
        });
      }
    },
    obtenerRelacionUsuarioServicio() {
      const relacionUs = this.usuario.servicios.find(
        (s) => s.id === this.$route.params.idServicio
      );
      if (!relacionUs) return;
      if (
        relacionUs.permisos.find((p) => p.permisoId === 2) ||
        relacionUs.rolId === 3 ||
        relacionUs.rolId === 4
      ) {
        this.permiso = true;
      }
    },

  },
  mounted() {
    setTimeout(() => {
      this.getImagenServicioOrganigrama();
    }, 200);
    this.obtenerRelacionUsuarioServicio();
    this.obtenerRevision();
    this.obtenerRelacionUsuarioServicios();
  },
};
</script>
<style scoped>
.cnt-img {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cnt-img > img {
  width: 50%;
}
</style>
